<template>
    <section>
        <div class="mt-2 container mx-auto px-2 py-1 sm:p-2 lg:p-4 bg-white rounded-lg">
            <button
              @click="addConfigDataHandler"
              v-if="activeSubConfig && activeSubConfig.displayName"
              class="float-right h-10 px-5 ml-3 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-800"
            >
              Add {{ activeSubConfig.displayName }}
            </button>
            <div class="flow-root overflow-x-auto inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table v-if="configData && configData.data && configData.data.data && configData.data.data.length" class="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                        <tr>
                            <th
                                v-for="(d, index) in fields"
                                :key="index"
                                scope="col"
                                class="pr-3 py-2 text-left text-sm font-semibold text-gray-900"
                            >
                                {{ d }}
                            </th>
                        </tr>
                    </thead>
                    <tbody
                        class="divide-y divide-gray-200 bg-white"
                    >
                    <!-- Selected: "bg-gray-50" -->
                    <tr v-for="(d, configIndex) in configData.data.data" :key="configIndex">
                        <td
                        class="whitespace-nowrap py-2 pr-3 text-sm font-medium text-blue-700 hover:underline capitalize truncate cursor-pointer"
                        > 
                            <a
                              @click="configDetailsHandler(d.id)"
                            >
                            {{ handleStr(d.banner_title, 40) }}
                            </a>
                        </td>
                        <td
                        class="whitespace-nowrap py-2 pr-3 text-sm font-medium text-gray-900 capitalize"
                        >
                        {{ d.product_type }}
                        </td>
                        <td
                        class="whitespace-nowrap px-3 py-2 text-sm text-gray-dark"
                        >
                        {{ d.position }}
                        </td>
                        <td
                        class="whitespace-nowrap px-3 py-2 text-sm text-gray-dark"
                        >
                        {{ d.status ? 'Active' : 'In-Active' }}
                        </td>
                        <td
                        class="whitespace-nowrap px-3 py-2 text-sm text-gray-dark"
                        >
                        {{ d.timer_start_time || "NA" }}
                        </td>
                        <td
                        class="whitespace-nowrap px-3 py-2 text-sm text-gray-dark"
                        >
                        {{ d.timer_end_time || "NA" }}
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-2 text-sm text-gray-dark cursor-pointer"
                          title="Delete"
                        >
                          <i
                            class="fa text-xl fa-trash-o text-red-600"
                            @click="deleteRecordInitHandler(d)"
                          ></i>
                        </td>
                    </tr>

                    <!-- More people... -->
                    </tbody>
                </table>
                <span class="flex justify-center" v-else-if="configData.statusCode === 404">No Data Available</span>
                <PaginationComponent
                v-if="configData && configData.data && configData.data.data && configData.data.data.length"
                :currentPage="configData.current_page"
                :handlePageChange="handlePageChange"
                :totalPages="configData.last_page"
                />
            </div>
        </div>
        <Modal
            :title="'Confirmation'" v-model="deletionConfirm"
            :handleClose="toggleDeletonModal"
            >
            <div class="rediret-warn flex flex-col items-center justify-end">
                <p>
                  Are you sure you want to Delete Config data?
                </p>
                <div class="flex items-center justify-end w-full pt-6">
                <button 
                    @click="deleteRecordHandler"
                    class="h-8 px-2 float-right text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"> 
                    Confirm
                </button>
                </div>
            </div>
        </Modal>
    </section>
</template>
<script>
import { PaginationComponent, Modal } from "@/components/t-components";
export default {
    name: 'AdminConfigData',
    components: {
      PaginationComponent,
      Modal
    },
    props: ['configData', 'handlePageChange', 'activeSubConfig', 'getAdminConfigFromStore'],
    data () {
        return {
            fields: [
                "Title",
                "Type",
                "Position",
                "Status",
                "Timer Start Date",
                "Timer End Date",
                "Action"
            ],
            deletionConfirm: false,
            deletionRecord: {}
        }
    },
    methods: {
      configDetailsHandler (id) {
        this.$emit('configDetails', {id: id})
      },
      addConfigDataHandler () {
        this.$emit('newConfigDetails')
      },
      toggleDeletonModal () {
        this.deletionConfirm = !this.deletionConfirm
      },
      deleteRecordInitHandler (dataObj) {
        this.deletionRecord = {...dataObj}
        this.toggleDeletonModal()
        // this.$store.dispatch('deleteConfigRecord', dataObj)
      },
      async deleteRecordHandler () {
        await this.$store.dispatch('deleteConfigRecord', this.deletionRecord).then(() => {
            this.toggleDeletonModal();
            this.getAdminConfigFromStore();
        })
      }
    }
}
</script>